/**
 * Single-listing photo gallery pagination.
 *
 * ListingDetail::render_gallery_block() already renders every image in the
 * gallery, with all but the first page's items carrying the native `hidden`
 * attribute — that is deliberate, not an oversight this file has to work
 * around: GLightbox (initialised generically in main.js) registers every
 * `.glightbox` element in the DOM regardless of its hidden state, so once a
 * lightbox is open its next/prev can still reach images on a page that is
 * not currently visible. This file only ever flips which page's `hidden`
 * attribute is set — it must never remove an item from the DOM, or
 * GLightbox's own navigation would stop being able to reach it.
 *
 * Concatenated after the vendor bundle and enqueued with `defer`, same as
 * every other file in this list — no DOMContentLoaded wrapper needed.
 */

( function () {
	'use strict';

	/**
	 * Shows one page's items in a gallery grid, hides the rest.
	 *
	 * @param {Element} grid Element carrying [data-gallery-grid].
	 * @param {string}  page Page number, as rendered in data-gallery-page.
	 */
	function activatePage( grid, page ) {
		var items = grid.querySelectorAll( '[data-gallery-page]' );

		Array.prototype.forEach.call( items, function ( item ) {
			item.hidden = page !== item.getAttribute( 'data-gallery-page' );
		} );
	}

	/**
	 * Wires one gallery's pagination controls to its grid.
	 *
	 * @param {Element} pagination Element carrying [data-pagination-for].
	 */
	function wirePagination( pagination ) {
		var galleryId = pagination.getAttribute( 'data-pagination-for' );
		var grid = document.querySelector( '[data-gallery-grid="' + galleryId + '"]' );

		if ( ! grid ) {
			return;
		}

		pagination.addEventListener( 'click', function ( event ) {
			var button = event.target.closest( '[data-page]' );

			if ( ! button ) {
				return;
			}

			var page = button.getAttribute( 'data-page' );
			var buttons = pagination.querySelectorAll( '[data-page]' );

			Array.prototype.forEach.call( buttons, function ( candidate ) {
				candidate.classList.toggle( 'listing-gallery__page-link--current', candidate === button );
			} );

			activatePage( grid, page );
		} );
	}

	Array.prototype.forEach.call(
		document.querySelectorAll( '.listing-gallery__pagination' ),
		wirePagination
	);
}() );
